<template>
  <div class="form_wrapper">
    <b-container fluid>
      <b-row>
        <b-col sm="3" lg="3">
          <b-form-group
            label="챕터"
            label-cols-sm="4"
            label-for="input-chapter"
          >
            <b-form-input
              :class="chapter_valid_cls"
              id="input-chapter"
              v-model="chapter"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="3" lg="3">
          <b-form-group label="유닛" label-cols-sm="4" label-for="input-unit">
            <b-form-input
              id="input-unit"
              :class="unit_valid_cls"
              v-model="unit"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>
        </b-col>

        <b-col offset-sm="1" offset-lg="1" sm="3" lg="3">
          <b-form-group label="문제순서" label-cols-sm="6">
            <b-form-input
              :class="qserial_valid_cls"
              id="input-qserial"
              v-model="qserial"
              placeholder="0"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="gray100" v-if="metaid == ''">
        <b-form-group label="학습유형">
          <b-form-radio-group
            v-model="std_type"
            :options="std_type_options"
            @change="chgStdType"
            name="radio-s-type"
          ></b-form-radio-group>
        </b-form-group>
      </div>
      <div class="fixed_std_type" v-else>
        <div class="title">학습유형</div>
        <div class="bd">{{ std_type_text }}</div>
      </div>

      <b-card header-tag="header" no-body v-if="std_type == '2'">
        <QType1Group class="groupenv" />
      </b-card>
      <b-card header-tag="header" no-body v-if="std_type == '3'">
        <QType1ReadingGroup class="groupenv" />
      </b-card>

      <!-- 문장훈련관련 -->
      <SenQForm v-if="std_type == '1'" />
      <!-- <WriQForm v-if="std_type == '3'" /> -->
    </b-container>
  </div>
</template>

<script>
import QType1 from "@/components/question/QType1";
import QType1Group from "@/components/question/QType1Group";
import QType1ReadingGroup from "@/components/question/QType1ReadingGroup";
import SenQForm from "@/components/question/SenQForm";
import WriQForm from "@/components/question/WriQForm";
export default {
  components: { QType1Group, SenQForm, /* WriQForm,*/ QType1ReadingGroup },
  watch: {
    grp_type(to, from) {
      this.single_disabled = false;
      this.group_disabled = false;

      if (this.grp_type == "1") {
        this.is_single = true;
        this.is_group = false;
        if (this.metaid != "") {
          this.single_disabled = false;
          this.group_disabled = true;
        }
      } else if (this.grp_type == "2") {
        this.is_single = false;
        this.is_group = true;
        if (this.metaid != "") {
          this.single_disabled = true;
          this.group_disabled = false;
        }
      }
    },
    std_type(to, from) {
      // reset all
      // console.log(to);
      // this.$store.dispatch("ResetForReady");
    },
  },

  data() {
    return {
      prevQType: false,
      is_single: true,
      is_group: false,
      single_disabled: false,
      group_disabled: false,
    };
  },
  computed: {
    metaid() {
      return this.$store.state.questionmeta.id;
    },

    chapter: {
      get() {
        return this.$store.state.questionmeta.chapter;
      },
      set(val) {
        this.$store.commit("updateChapter", val);
        // this.$store.commit("updateQType", val);
      },
    },
    chapter_valid_cls() {
      return this.$store.state.valid.chapter;
    },
    unit_valid_cls() {
      return this.$store.state.valid.unit;
    },

    qserial_valid_cls() {
      return this.$store.state.valid.qserial;
    },

    unit: {
      get() {
        return this.$store.state.questionmeta.unit;
      },
      set(val) {
        this.$store.commit("updateUnit", val);
      },
    },
    qserial: {
      get() {
        return this.$store.state.questionmeta.qserial;
      },
      set(val) {
        this.$store.commit("updateQSerial", val);
      },
    },
    std_type: {
      get() {
        return this.$store.state.questionmeta.std_type;
      },
      set(val) {
        this.$store.commit("updateStdType", val);
      },
    },
    std_type_text() {
      let pos = parseInt(this.std_type);
      return this.$store.state.std_type_options[pos - 1].text;
    },

    std_type_options() {
      return this.$store.state.std_type_options;
    },
    grp_type: {
      get() {
        return this.$store.state.questionmeta.grp_type;
      },
      set(val) {
        this.$store.commit("updateGrpType", val);
      },
    },
  },
  methods: {
    chgStdType(val) {
      this.$store.commit("updateStdType", val);
      this.$store.dispatch("ResetForReady");
    },
    single(val) {
      // this.tabIndex = 1;
      this.$store.commit("updateGrpType", 1);
      this.$store.commit("udpateTabindex", 1);

      // this.$store.commit("updateDebug", "개별문항선택");
      this.$store.commit("resetQuestionOnly");

      this.$store.commit("updateStatement", "");
    },
    group(val) {
      if (this.q_type == "5") {
        alert("그룹문항타입은 지원하지 않습니다");
      } else {
        this.$store.commit("updateGrpType", 2);
        this.$store.commit("resetQuestionOnly");
        this.$store.commit("updateStatement", "");
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.groupenv {
  padding-left: 10px;
  padding-right: 10px;
}
h1.warning {
  background: crimson;
  color: yellow;
}

.invalid {
  border: 2px solid red;
}

.gray100 {
  background-color: $gray200;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.qtype_wrapper {
  display: flex;
}

.fixed_std_type {
  background-color: $gray200;
  border-radius: 5px;
  min-height: 60px;
  padding: 5px 10px 5px 10px;
  margin-bottom: 5px;
  .title {
  }
  .bd {
    font-weight: 700;
  }
}

.fixed_q_type {
  border-radius: 5px;
  min-height: 60px;
  padding: 5px 10px 5px 10px;
  .title {
  }
  .bd {
    font-weight: 700;
  }
}
</style>